var exports = {
  "kL": "x127c5a35--2773d1--container",
  "rQ": "x127c5a35--2773d1--container_active",
  "$q": "x127c5a35--2773d1--card_container",
  "Hb": "x127c5a35--2773d1--info_container",
  "_H": "x127c5a35--2773d1--comment_container",
  "RC": "x127c5a35--2773d1--preloader",
};

module.exports = exports;
